export default "/images/company3.jpg?5d639a49c60155cbcd48f9e207d74cfb";